import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "trial-checkboxes w-full flex justify-content-between align-items-center" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 1,
  class: "trial-checkboxes__edit flex flex-row"
}
const _hoisted_4 = { class: "px-1 increment-container" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "checkbox-container flex-wrap" }
const _hoisted_7 = { class: "px-1 increment-container" }
const _hoisted_8 = ["disabled"]

import { onMounted, ref, toRefs, watch, Ref, inject, computed } from 'vue';
import InputNumber from 'primevue/inputnumber';
import { TRIAL_GOAL_PARAMS } from '@/enum';
import { TrialGoalInterface } from '@/types';
import Chip from 'primevue/chip';

interface PropsInterface {
  attendeeId: number;
  trial: TrialGoalInterface;
  disabled: boolean;
  displayPastEvents: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GoalsCheckbox',
  props: {
    attendeeId: {},
    trial: {},
    disabled: { type: Boolean },
    displayPastEvents: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

//inject the function from the grandparent DocEventModal to skip all the emit injections
const updateTrialGoal = inject('updateTrialGoal') as (
  checkboxArray: number[],
  max: number,
  id: number,
  trialId: number,
  trialCount: number,
  percentage: number,
) => void;
const { trial, attendeeId, displayPastEvents } = toRefs(props);
const selectedValueArray: Ref<number[]> = ref([]);
const totalValueArray: Ref<number[]> = ref(Array(trial.value.total_trials).fill(0));
const updateDisabled: Ref<boolean> = ref(true);
const maxValue: Ref<number> = ref(trial.value.total_trials);
const percentage: Ref<number> = ref(trial.value.percentage || 0);
const trialCount: Ref<number> = ref(trial.value.trials);

onMounted(() => {
  setSelectedValueArray();
  setTrialTotal();
  //TODO: skipping this until we figure out if we need it
  //getTrialBitTotal();
});

/**
 * set up the selectedValueArray based on the incoming checkbox_order array
 */
const setSelectedValueArray = () => {
  if (trial.value.checkbox_order) {
    trial.value.checkbox_order?.forEach((item, index) => {
      if (item === 1) {
        selectedValueArray.value.push(index);
      }
    });
  }
};
/**
 * TODO: is this necessary? there is no bit table in the DB
 */
// const getTrialBitTotal = () => {
//   let bitfieldDefault = 1;
//   let bitfield = 0;

//   selectedValueArray.value.forEach((trial) => {
//     bitfield |= bitfieldDefault;

//     bitfieldDefault <<= 1;
//   });
//   setTrialTotal();
// };

/**
 * Set the calculated trial percentage and trial total.
 *
 * @return {Void}
 */
const setTrialTotal = () => {
  trialCount.value = selectedValueArray.value.filter((item) => item != 0).length;
  percentage.value = Math.round((trialCount.value / trial.value.total_trials) * 100);
};

/**
 * handle changing the max size and checkbox selections
 */
const handleChange = () => {
  mergeArrays();
  setTrialTotal();
  update();
};

/**
 * merge the selected values indexes into the total value array
 *
 */
const mergeArrays = () => {
  //set all the totalValueArray items to unchecked
  totalValueArray.value = Array(trial.value.total_trials).fill(0);

  //if there are any selected values greater than the max then filter them out
  selectedValueArray.value = selectedValueArray.value.filter((val) => val <= trial.value.total_trials);

  //each selected value in the array is actually the INDEX position-1 to set to 1 (checked)
  selectedValueArray.value.forEach((val) => {
    totalValueArray.value[val] = 1;
  });
};

watch(() => trial.value.total_trials, handleChange);

const decrementMax = () => {
  if (maxValue.value === TRIAL_GOAL_PARAMS.MIN_ALLOWED) return;
  maxValue.value--;
  update();
};

const incrementMax = () => {
  if (maxValue.value === TRIAL_GOAL_PARAMS.MAX_ALLOWED) return;
  maxValue.value++;
  update();
};

/**
 * handle the text input update for max
 */
const handleInputUpdate = () => {
  if (isOutOfBounds.value) return;
  update();
  updateDisabled.value = true;
};

/**
 * update the grandparent
 */
const update = () =>
  updateTrialGoal(
    totalValueArray.value,
    maxValue.value,
    attendeeId.value,
    trial.value.treatment_goal_id,
    trialCount.value,
    percentage.value,
  );

const isOutOfBounds = computed(
  () => maxValue.value > TRIAL_GOAL_PARAMS.MAX_ALLOWED || maxValue.value < TRIAL_GOAL_PARAMS.MIN_ALLOWED,
);

const enableUpdate = () => (updateDisabled.value = false);

const cancelUpdate = () => {
  maxValue.value = trial.value.total_trials;
  updateDisabled.value = true;
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex w-full", _unref(displayPastEvents) ? 'grid' : ''])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex align-items-center", _unref(displayPastEvents) ? 'flex-order-0 col-6 xl:col-3' : ''])
      }, [
        _createVNode(_unref(InputNumber), {
          modelValue: maxValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((maxValue).value = $event)),
          disabled: updateDisabled.value,
          max: _unref(TRIAL_GOAL_PARAMS).MAX_ALLOWED,
          min: _unref(TRIAL_GOAL_PARAMS).MIN_ALLOWED,
          class: "trial-checkboxes__max"
        }, null, 8, ["modelValue", "disabled", "max", "min"]),
        (updateDisabled.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              disabled: __props.disabled,
              class: "button edit border-noround pr-2 m-0",
              onClick: enableUpdate
            }, [
              _createVNode(_component_Icon, {
                name: "edit",
                class: "text-base"
              })
            ], 8, _hoisted_2))
          : _createCommentVNode("", true),
        (!updateDisabled.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("button", {
                class: "button close border-round-sm w-1rem h-1rem font-bold",
                onClick: cancelUpdate
              }, [
                _createVNode(_component_Icon, { name: "close" })
              ]),
              _createElementVNode("button", {
                class: "button check border-round-sm w-1rem h-1rem font-bold",
                onClick: handleInputUpdate
              }, [
                _createVNode(_component_Icon, { name: "check" })
              ])
            ]))
          : _createCommentVNode("", true),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "divider" }, " ", -1))
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["flex flex-1 align-items-center", 
          _unref(displayPastEvents)
            ? 'flex-order-2 col-12 justify-content-center xl:flex-order-1 xl:justify-content-start xl:col-7'
            : ''
        ])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "subtract button",
            disabled: !updateDisabled.value || __props.disabled,
            onClick: decrementMax
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("span", { class: "material-icons-round" }, "remove", -1)
          ]))], 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(trial).total_trials, (number) => {
            return (_openBlock(), _createBlock(_component_Checkbox, {
              key: number,
              modelValue: selectedValueArray.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedValueArray).value = $event)),
              disabled: __props.disabled,
              value: number,
              class: "border-noround",
              onChange: handleChange
            }, null, 8, ["modelValue", "disabled", "value"]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            class: "add button",
            disabled: !updateDisabled.value || __props.disabled,
            onClick: incrementMax
          }, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("span", { class: "material-icons-round" }, "add", -1)
          ]))], 8, _hoisted_8)
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["flex align-self-center justify-content-end", _unref(displayPastEvents) ? 'flex-order-1 col-6 xl:flex-order-2 xl:col-2' : ''])
      }, [
        _createVNode(_unref(Chip), { class: "total font-bold justify-content-center" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(percentage.value) + "%", 1)
          ]),
          _: 1
        })
      ], 2)
    ], 2)
  ]))
}
}

})